
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3421"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3421"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5jD8l", function(module, exports) {

$parcel$export(module.exports, "injectIcons", () => $3ded15367f284944$export$12bcc748352b0fb);
const $3ded15367f284944$var$attrs = 'xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"';
const $3ded15367f284944$export$df03f54e09e486fa = {
    menu: `<svg ${$3ded15367f284944$var$attrs} viewBox="0 0 24 24" aria-hidden="true"><path d="M5 9.5c0-2.2 2.4-3.8 7-3.8s7 1.6 7 3.8c0 .7-.3 1.3-.8 1.7H5.8c-.5-.4-.8-1-.8-1.7z"/><rect x="4.5" y="12.8" width="15" height="2.8" rx="1.4" fill="currentColor" stroke="none"/><path d="M5.5 16.8h13c.7 0 1.2.5 1.2 1.2v.8c0 .7-.5 1.2-1.2 1.2h-13c-.7 0-1.2-.5-1.2-1.2v-.8c0-.7.5-1.2 1.2-1.2z" fill="currentColor" stroke="none" opacity=".85"/><circle cx="9" cy="18.8" r=".75" fill="var(--bm-bg, #0c0b0a)" stroke="none"/><circle cx="15" cy="18.8" r=".75" fill="var(--bm-bg, #0c0b0a)" stroke="none"/><path d="M8 10c1-.6 2.2-.9 4-.9s3 .3 4 .9"/></svg>`,
    branches: `<svg ${$3ded15367f284944$var$attrs} viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>`,
    accessibility: `<svg ${$3ded15367f284944$var$attrs} viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="4.5" r="1.75" fill="currentColor" stroke="none"/><path d="M7 8.5h10M12 8.5v5.5M9.5 20l2.5-6 2.5 6M7.5 13.5 5 20M16.5 13.5 19 20"/></svg>`,
    events: `<svg ${$3ded15367f284944$var$attrs} viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/><path d="M8 14h.01M12 14h.01M16 14h.01M8 17h.01M12 17h.01"/></svg>`,
    parking: `<svg ${$3ded15367f284944$var$attrs} viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M9 7h3.5a3 3 0 0 1 0 6H11v5"/></svg>`,
    phone: `<svg ${$3ded15367f284944$var$attrs} viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 4h3l1.5 5-2 1.2a11 11 0 0 0 5.3 5.3L16 14l5 1.5v3a2 2 0 0 1-2.1 2A15 15 0 0 1 4 6.1 2 2 0 0 1 6.5 4z"/></svg>`,
    waze: `<svg ${$3ded15367f284944$var$attrs} viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8.5 10.5a3.5 3.5 0 0 1 7 0c0 2.2-1.8 4.5-3.5 6.5-1.7-2-3.5-4.3-3.5-6.5z"/><circle cx="12" cy="10.5" r="1" fill="currentColor" stroke="none"/></svg>`,
    arrowRight: `<svg ${$3ded15367f284944$var$attrs} viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>`,
    mail: `<svg ${$3ded15367f284944$var$attrs} viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>`
};
function $3ded15367f284944$export$12bcc748352b0fb() {
    document.querySelectorAll("[data-icon]").forEach((el)=>{
        const name = el.dataset.icon;
        if ($3ded15367f284944$export$df03f54e09e486fa[name]) el.innerHTML = $3ded15367f284944$export$df03f54e09e486fa[name];
    });
}

});

parcelRegister("amjSx", function(module, exports) {

$parcel$export(module.exports, "sanitizeCmsStorage", () => $78ab60f00f1c160f$export$605f528e3181fa45);
$parcel$export(module.exports, "loadCms", () => $78ab60f00f1c160f$export$94db5ff3b913fcae);
$parcel$export(module.exports, "saveCms", () => $78ab60f00f1c160f$export$1586565df91ed028);
$parcel$export(module.exports, "isAdminAuthed", () => $78ab60f00f1c160f$export$a921bfc4fb7eaf31);
$parcel$export(module.exports, "initCmsFromServer", () => $78ab60f00f1c160f$export$497a4c6b4b88adf2);
$parcel$export(module.exports, "syncCmsToServer", () => $78ab60f00f1c160f$export$3b701d8d37f7b5c8);
$parcel$export(module.exports, "getCmsMenu", () => $78ab60f00f1c160f$export$3ca6f8db0e80f1fc);
$parcel$export(module.exports, "getBranchList", () => $78ab60f00f1c160f$export$964989421456ce43);
$parcel$export(module.exports, "getCmsBranches", () => $78ab60f00f1c160f$export$b99bedcde7d50788);
$parcel$export(module.exports, "getDefaultBranches", () => $78ab60f00f1c160f$export$926b1ab228518923);
$parcel$export(module.exports, "addBranch", () => $78ab60f00f1c160f$export$9fc3579d7ef92f11);
$parcel$export(module.exports, "removeBranch", () => $78ab60f00f1c160f$export$8640b42afbd128bb);
$parcel$export(module.exports, "refreshAdminSession", () => $78ab60f00f1c160f$export$20eeae30a7d8c1c7);
$parcel$export(module.exports, "loginAdmin", () => $78ab60f00f1c160f$export$8d9bfe7f2249575a);
$parcel$export(module.exports, "logoutAdmin", () => $78ab60f00f1c160f$export$a61ab06a008dc00d);
$parcel$export(module.exports, "addMenuItem", () => $78ab60f00f1c160f$export$5ca91be321d38a98);
$parcel$export(module.exports, "removeMenuItem", () => $78ab60f00f1c160f$export$734ea83f1557b6fd);
$parcel$export(module.exports, "addMenuSection", () => $78ab60f00f1c160f$export$4a43ff263d8ea6cd);
$parcel$export(module.exports, "removeMenuSection", () => $78ab60f00f1c160f$export$ea76e1ade20dfa99);
$parcel$export(module.exports, "getGalleryList", () => $78ab60f00f1c160f$export$6c3ff35ca991ad1e);
$parcel$export(module.exports, "addGalleryItem", () => $78ab60f00f1c160f$export$17c5d60a1a4ae7ad);
$parcel$export(module.exports, "removeGalleryItem", () => $78ab60f00f1c160f$export$3dbe701bb09975e8);
$parcel$export(module.exports, "persistGalleryField", () => $78ab60f00f1c160f$export$e2c9a5bad3d7a101);
$parcel$export(module.exports, "getGalleryFieldValue", () => $78ab60f00f1c160f$export$74bde387a297287f);
$parcel$export(module.exports, "getHeroSlides", () => $78ab60f00f1c160f$export$8ccf9b9807721612);
$parcel$export(module.exports, "addHeroSlide", () => $78ab60f00f1c160f$export$3c9497e0f78fc31b);
$parcel$export(module.exports, "removeHeroSlide", () => $78ab60f00f1c160f$export$2728136bea1f57a3);
$parcel$export(module.exports, "persistHeroField", () => $78ab60f00f1c160f$export$7c94d757969729ab);
$parcel$export(module.exports, "getHeroFieldValue", () => $78ab60f00f1c160f$export$af83fdf91bbc50e3);
$parcel$export(module.exports, "getStoryParagraphs", () => $78ab60f00f1c160f$export$f5e1209a388a275c);
$parcel$export(module.exports, "addStoryParagraph", () => $78ab60f00f1c160f$export$adf0993945ee3e86);
$parcel$export(module.exports, "removeStoryParagraph", () => $78ab60f00f1c160f$export$4086df54b404ea87);
$parcel$export(module.exports, "persistStoryParagraph", () => $78ab60f00f1c160f$export$deddb0f114322c4c);
$parcel$export(module.exports, "getStoryParagraphValue", () => $78ab60f00f1c160f$export$5471562007a6009);
$parcel$export(module.exports, "persistMenuField", () => $78ab60f00f1c160f$export$350ef79c0617f8ee);
$parcel$export(module.exports, "getMenuFieldValue", () => $78ab60f00f1c160f$export$b7b5d860b0808a2d);

var $2xpOo = parcelRequire("2xpOo");

var $hHYpn = parcelRequire("hHYpn");
var $dlkUe = parcelRequire("dlkUe");

var $fczhV = parcelRequire("fczhV");

var $fneK1 = parcelRequire("fneK1");

var $fGko7 = parcelRequire("fGko7");

var $aStCm = parcelRequire("aStCm");

var $66oNf = parcelRequire("66oNf");
const $78ab60f00f1c160f$var$CMS_KEY = "burgermunch-cms";
const $78ab60f00f1c160f$var$AUTH_KEY = "burgermunch-cms-auth";
const $78ab60f00f1c160f$var$defaultBranches = {
    shomron: {
        title: "\u05E1\u05E0\u05D9\u05E3 \u05E7\u05E8\u05E0\u05D9 \u05E9\u05D5\u05DE\u05E8\u05D5\u05DF",
        branch: "\u05E7\u05E8\u05E0\u05D9 \u05E9\u05D5\u05DE\u05E8\u05D5\u05DF",
        address: "\u05DE\u05EA\u05D7\u05DD \u05EA\u05D7\u05E0\u05EA \u05D3\u05DC\u05E7 \u05D3\u05D5\u05E8 \u05D0\u05DC\u05D5\u05DF, \u05E7\u05E8\u05E0\u05D9 \u05E9\u05D5\u05DE\u05E8\u05D5\u05DF",
        time: "\u05D0' \u2013 \u05D4' | 22:45 \u2013 12:00",
        waze: "https://ul.waze.com/ul?place=ChIJ2SFrr7QjHRURM7HJUuMnBuI&ll=32.17507710%2C35.09289750&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3377.081325894499!2d35.09508082067761!3d32.17508162183217!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d23b4af6b21d9%3A0xe20627e352c9b133!2z15HXldeo15LXqCDXmNeZ15nXnSDXp9eo16DXmSDXqdeV157XqNeV158!5e0!3m2!1siw!2sil!4v1661950762454!5m2!1siw!2sil",
        image: "../pic/karniSOM.jpg"
    },
    telmon: {
        title: "\u05E1\u05E0\u05D9\u05E3 \u05D8\u05DC\u05DE\u05D5\u05DF",
        branch: "\u05D8\u05DC\u05DE\u05D5\u05DF",
        address: "\u05D4\u05E2\u05E8\u05DE\u05D5\u05DF 2002, \u05D8\u05DC\u05DE\u05D5\u05DF",
        time: "\u05D0' \u2013 \u05D4' | 22:45 \u2013 12:00 | \u05DE\u05D5\u05E6\u05D0\u05D9 \u05E9\u05D1\u05EA: \u05E9\u05E2\u05D4 \u05DE\u05E6\u05D0\u05EA \u05D4\u05E9\u05D1\u05EA \u05E2\u05D3 00:00",
        waze: "https://ul.waze.com/ul?preview_venue_id=23003455.230231162.582198&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2013.2238933861474!2d35.13442045326765!3d31.938494384521324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d2b20969593ed%3A0xc76e8937071f855!2zQnVyZ2VyTXVuY2gg15HXldeo15LXqCDXnteQ16DXpSAtINeh16DXmdejINeY15zXnteV158gLSDXm9ep16g!5e0!3m2!1siw!2sil!4v1661950425157!5m2!1siw!2sil",
        image: "../pic/talmon2.jpg"
    },
    beitel: {
        title: "\u05E1\u05E0\u05D9\u05E3 \u05D1\u05D9\u05EA \u05D0\u05DC",
        branch: "\u05D1\u05D9\u05EA \u05D0\u05DC",
        address: "\u05EA\u05D5\u05E8\u05D4 \u05D5\u05E2\u05D1\u05D5\u05D3\u05D4 4, \u05D1\u05D9\u05EA \u05D0\u05DC",
        time: "\u05D0' \u2013 \u05D4' | 22:45 \u2013 12:00",
        waze: "https://ul.waze.com/ul?place=ChIJ0zw5jo_VHBURFmWbYcoQTtM&ll=31.94227640%2C35.22400750&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4026.2742401791957!2d35.228116340431974!3d31.942455716962634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151cd58f8e393cd3%3A0xd34e10ca619b6516!2z16rXldeo15Qg15XXoteR15XXk9eUIDQsIEJlaXQgRWw!5e0!3m2!1siw!2sil!4v1661950560686!5m2!1siw!2sil",
        image: "../pic/orders1.jpeg"
    },
    tapuach: {
        title: "\u05E1\u05E0\u05D9\u05E3 \u05EA\u05E4\u05D5\u05D7",
        branch: "\u05EA\u05E4\u05D5\u05D7",
        address: "\u05E6\u05D5\u05DE\u05EA \u05EA\u05E4\u05D5\u05D7, \u05EA\u05E4\u05D5\u05D7",
        time: "\u05D0' \u2013 \u05D4' | 00:00 \u2013 12:00 | \u05DE\u05D5\u05E6\u05D0\u05D9 \u05E9\u05D1\u05EA: \u05E9\u05E2\u05D4 \u05DE\u05E6\u05D0\u05EA \u05D4\u05E9\u05D1\u05EA \u05E2\u05D3 00:00",
        waze: "https://ul.waze.com/ul?preview_venue_id=23134529.231083148.491557&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2009.314763966906!2d35.257929913578685!3d32.11651858346549!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d2542c2cee53d%3A0x1c337d634854acee!2zQnVyZ2VyVGltZSDXkdeV16jXkteoINeY15nXmdedLSDXodeg15nXoyDXqtek15XXlyAtINeb16nXqA!5e0!3m2!1siw!2sil!4v1661950658784!5m2!1siw!2sil",
        image: "../pic/tapuach.jpg"
    },
    ariel: {
        title: "\u05E1\u05E0\u05D9\u05E3 \u05D0\u05E8\u05D9\u05D0\u05DC",
        branch: "\u05D0\u05E8\u05D9\u05D0\u05DC",
        address: "\u05DE\u05E8\u05DB\u05D6 \u05DE\u05E1\u05D7\u05E8\u05D9 \u05E8\u05D5\u05D1\u05E2 \u05D0', \u05D0\u05E8\u05D9\u05D0\u05DC",
        time: "\u05D0' \u2013 \u05D4' | 22:45 \u2013 12:00",
        waze: "https://ul.waze.com/ul?preview_venue_id=23068993.230493323.582618&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
        map: "https://www.google.com/maps/embed?pb=!1m21!1m12!1m3!1d211.22861423252317!2d35.17283954076784!3d32.10553229326257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m6!3e6!4m0!4m3!3m2!1d32.1055275!2d35.1727091!5e0!3m2!1siw!2sil!4v1661950286223!5m2!1siw!2sil",
        image: "../pic/ariel.jpg"
    },
    yakir: {
        title: "\u05E1\u05E0\u05D9\u05E3 \u05D9\u05E7\u05D9\u05E8",
        branch: "\u05D9\u05E7\u05D9\u05E8",
        address: "\u05E9\u05D3\u05E8\u05D5\u05EA \u05D4\u05E8\u05D0\u05E9\u05D5\u05E0\u05D9\u05DD, \u05D9\u05E7\u05D9\u05E8",
        time: "\u05D0' \u2013 \u05D4' | 22:45 \u2013 12:00",
        waze: "https://ul.waze.com/ul?preview_venue_id=23003457.230165647.334414&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3378.028124841077!2d35.11747118547082!3d32.14953962302175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151d24175681ee0d%3A0xf08d2fbf5d8772dc!2z16nXk9eo15XXqiDXlNeo15DXqdeV16DXmdedLCDXmden15nXqA!5e0!3m2!1siw!2sil!4v1660665446094!5m2!1siw!2sil",
        image: "../pic/yakir.jpg"
    }
};
function $78ab60f00f1c160f$export$605f528e3181fa45() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    let changed = false;
    const defaults = $78ab60f00f1c160f$var$defaultBranches;
    if (cms.branches) {
        for (const [id, branch] of Object.entries({
            ...cms.branches
        })){
            if (branch.image && !(0, $hHYpn.shouldPersistImage)(branch.image, defaults[id]?.image)) {
                delete cms.branches[id].image;
                changed = true;
            }
            if (cms.branches[id] && !Object.keys(cms.branches[id]).length) {
                delete cms.branches[id];
                changed = true;
            }
        }
        if (cms.branches && !Object.keys(cms.branches).length) {
            delete cms.branches;
            changed = true;
        }
    }
    if (Array.isArray(cms.branchList)) {
        if (cms.branchList.length === 0) {
            delete cms.branchList;
            changed = true;
        } else cms.branchList = cms.branchList.map((branch)=>{
            const next = {
                ...branch
            };
            const defaultImage = defaults[branch.id]?.image;
            if (next.image && !(0, $hHYpn.shouldPersistImage)(next.image, defaultImage)) {
                delete next.image;
                changed = true;
            }
            return next;
        });
    }
    if (cms.images) {
        for (const [key, value] of Object.entries({
            ...cms.images
        }))if (typeof value === "string" && (0, $dlkUe.isLegacyPicPath)(value)) {
            delete cms.images[key];
            changed = true;
        }
        if (!Object.keys(cms.images).length) {
            delete cms.images;
            changed = true;
        }
    }
    if (changed) $78ab60f00f1c160f$export$1586565df91ed028(cms);
}
let $78ab60f00f1c160f$var$cmsInitPromise = null;
let $78ab60f00f1c160f$var$serverSyncTimer = null;
function $78ab60f00f1c160f$export$94db5ff3b913fcae() {
    try {
        const raw = localStorage.getItem($78ab60f00f1c160f$var$CMS_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch  {
        return {};
    }
}
function $78ab60f00f1c160f$export$1586565df91ed028(data, { syncToServer: syncToServer = false } = {}) {
    localStorage.setItem($78ab60f00f1c160f$var$CMS_KEY, JSON.stringify(data));
    if (syncToServer || $78ab60f00f1c160f$export$a921bfc4fb7eaf31()) $78ab60f00f1c160f$var$scheduleServerSync(data);
}
function $78ab60f00f1c160f$export$497a4c6b4b88adf2() {
    if (!$78ab60f00f1c160f$var$cmsInitPromise) $78ab60f00f1c160f$var$cmsInitPromise = (0, $66oNf.fetchRemoteCms)().then(async (remote)=>{
        if ((0, $66oNf.hasRemoteCmsContent)(remote)) {
            localStorage.setItem($78ab60f00f1c160f$var$CMS_KEY, JSON.stringify(remote));
            return;
        }
        const local = $78ab60f00f1c160f$export$94db5ff3b913fcae();
        if ($78ab60f00f1c160f$export$a921bfc4fb7eaf31() && (0, $66oNf.hasRemoteCmsContent)(local)) await (0, $66oNf.pushRemoteCms)(local).catch(()=>{
        /* admin can retry via Save */ });
    }).catch(()=>{
    /* local dev or API unavailable — keep localStorage/defaults */ });
    return $78ab60f00f1c160f$var$cmsInitPromise;
}
function $78ab60f00f1c160f$var$scheduleServerSync(data) {
    clearTimeout($78ab60f00f1c160f$var$serverSyncTimer);
    $78ab60f00f1c160f$var$serverSyncTimer = setTimeout(()=>{
        (0, $66oNf.pushRemoteCms)(data).catch(()=>{
        /* network errors are surfaced by explicit save action */ });
    }, 600);
}
async function $78ab60f00f1c160f$export$3b701d8d37f7b5c8() {
    clearTimeout($78ab60f00f1c160f$var$serverSyncTimer);
    await (0, $66oNf.pushRemoteCms)($78ab60f00f1c160f$export$94db5ff3b913fcae());
}
function $78ab60f00f1c160f$export$83a1473bdc30129d(key) {
    const data = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    return data.text?.[key];
}
function $78ab60f00f1c160f$export$3ca6f8db0e80f1fc() {
    const data = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    return data.menu ?? null;
}
function $78ab60f00f1c160f$export$5f0845881c5cc909() {
    return Object.entries($78ab60f00f1c160f$var$defaultBranches).map(([id, data])=>({
            id: id,
            ...structuredClone(data)
        }));
}
function $78ab60f00f1c160f$export$964989421456ce43() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    if (Array.isArray(cms.branchList) && cms.branchList.length > 0) return cms.branchList.map((branch)=>({
            ...branch
        }));
    return $78ab60f00f1c160f$export$5f0845881c5cc909().map((branch)=>({
            ...branch,
            ...cms.branches?.[branch.id] ?? {}
        }));
}
function $78ab60f00f1c160f$export$b99bedcde7d50788() {
    const list = $78ab60f00f1c160f$export$964989421456ce43();
    return Object.fromEntries(list.map((branch)=>[
            branch.id,
            branch
        ]));
}
function $78ab60f00f1c160f$export$926b1ab228518923() {
    return structuredClone($78ab60f00f1c160f$var$defaultBranches);
}
function $78ab60f00f1c160f$var$materializeBranchList(cms) {
    if (!Array.isArray(cms.branchList)) cms.branchList = $78ab60f00f1c160f$export$5f0845881c5cc909().map((branch)=>({
            ...branch,
            ...cms.branches?.[branch.id] ?? {}
        }));
    return cms.branchList;
}
function $78ab60f00f1c160f$export$9fc3579d7ef92f11() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeBranchList(cms);
    const id = `branch-${Date.now()}`;
    list.push({
        id: id,
        ...(0, $fneK1.createEmptyBranch)()
    });
    cms.branchList = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
    return id;
}
function $78ab60f00f1c160f$export$8640b42afbd128bb(branchId) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeBranchList(cms);
    if (list.length <= 1) return false;
    const next = list.filter((branch)=>branch.id !== branchId);
    if (next.length === list.length) return false;
    cms.branchList = next;
    if (cms.branches?.[branchId]) {
        delete cms.branches[branchId];
        if (!Object.keys(cms.branches).length) delete cms.branches;
    }
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
    return true;
}
function $78ab60f00f1c160f$export$b59bc15d9bae6f2a() {
    return structuredClone((0, $2xpOo.menuSections));
}
function $78ab60f00f1c160f$export$a921bfc4fb7eaf31() {
    return sessionStorage.getItem($78ab60f00f1c160f$var$AUTH_KEY) === "1";
}
async function $78ab60f00f1c160f$export$20eeae30a7d8c1c7() {
    try {
        const session = await (0, $aStCm.readSession)();
        if (session.authenticated) sessionStorage.setItem($78ab60f00f1c160f$var$AUTH_KEY, "1");
        else sessionStorage.removeItem($78ab60f00f1c160f$var$AUTH_KEY);
        return session.authenticated === true;
    } catch  {
        sessionStorage.removeItem($78ab60f00f1c160f$var$AUTH_KEY);
        return false;
    }
}
async function $78ab60f00f1c160f$export$8d9bfe7f2249575a(user, pass) {
    await (0, $aStCm.authenticate)(user, pass);
    sessionStorage.setItem($78ab60f00f1c160f$var$AUTH_KEY, "1");
    return true;
}
async function $78ab60f00f1c160f$export$a61ab06a008dc00d() {
    await (0, $aStCm.endSession)();
    clearTimeout($78ab60f00f1c160f$var$serverSyncTimer);
    sessionStorage.removeItem($78ab60f00f1c160f$var$AUTH_KEY);
}
function $78ab60f00f1c160f$export$5ca91be321d38a98(sectionId) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const menu = cms.menu ?? $78ab60f00f1c160f$export$b59bc15d9bae6f2a();
    const section = menu.find((s)=>s.id === sectionId);
    if (!section) return false;
    section.items.push((0, $fczhV.createEmptyMenuItem)());
    cms.menu = menu;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
    return true;
}
function $78ab60f00f1c160f$export$734ea83f1557b6fd(sectionId, itemIndex) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const menu = cms.menu ?? $78ab60f00f1c160f$export$b59bc15d9bae6f2a();
    const section = menu.find((s)=>s.id === sectionId);
    if (!section) return false;
    if (section.items.length <= 1) return false;
    if (itemIndex < 0 || itemIndex >= section.items.length) return false;
    section.items.splice(itemIndex, 1);
    cms.menu = menu;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
    return true;
}
function $78ab60f00f1c160f$export$4a43ff263d8ea6cd() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const menu = cms.menu ?? $78ab60f00f1c160f$export$b59bc15d9bae6f2a();
    const id = `category-${Date.now()}`;
    menu.push({
        id: id,
        title: "\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4 \u05D7\u05D3\u05E9\u05D4",
        items: [
            (0, $fczhV.createEmptyMenuItem)()
        ]
    });
    cms.menu = menu;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
    return id;
}
function $78ab60f00f1c160f$export$ea76e1ade20dfa99(sectionId) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const menu = cms.menu ?? $78ab60f00f1c160f$export$b59bc15d9bae6f2a();
    if (menu.length <= 1) return false;
    const next = menu.filter((section)=>section.id !== sectionId);
    if (next.length === menu.length) return false;
    cms.menu = next;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
    return true;
}
function $78ab60f00f1c160f$var$materializeGallery(cms) {
    if (!Array.isArray(cms.gallery)) cms.gallery = (0, $fGko7.defaultGallery).map((item, index)=>{
        const override = cms.images?.[`images.gallery.${index + 1}`];
        return override ? {
            ...item,
            src: override
        } : {
            ...item
        };
    });
    return cms.gallery;
}
function $78ab60f00f1c160f$export$6c3ff35ca991ad1e() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    return $78ab60f00f1c160f$var$materializeGallery(cms).map((item)=>({
            ...item
        }));
}
function $78ab60f00f1c160f$export$17c5d60a1a4ae7ad() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeGallery(cms);
    list.push((0, $fGko7.createEmptyGalleryItem)());
    cms.gallery = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
}
function $78ab60f00f1c160f$export$3dbe701bb09975e8(index) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeGallery(cms);
    if (list.length <= 1 || index < 0 || index >= list.length) return false;
    list.splice(index, 1);
    cms.gallery = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
    return true;
}
function $78ab60f00f1c160f$export$e2c9a5bad3d7a101(index, fieldName, value) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeGallery(cms);
    if (!list[index]) return;
    list[index] = {
        ...list[index],
        [fieldName]: value
    };
    cms.gallery = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
}
function $78ab60f00f1c160f$export$74bde387a297287f(index, fieldName) {
    return $78ab60f00f1c160f$export$6c3ff35ca991ad1e()[index]?.[fieldName] ?? "";
}
function $78ab60f00f1c160f$var$materializeHeroSlides(cms) {
    if (!Array.isArray(cms.heroSlides)) cms.heroSlides = (0, $fGko7.defaultHeroSlides).map((slide, index)=>{
        const override = cms.images?.[`images.hero.${index + 1}`];
        return override ? {
            ...slide,
            src: override
        } : {
            ...slide
        };
    });
    return cms.heroSlides;
}
function $78ab60f00f1c160f$export$8ccf9b9807721612() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    return $78ab60f00f1c160f$var$materializeHeroSlides(cms).map((slide)=>({
            ...slide
        }));
}
function $78ab60f00f1c160f$export$3c9497e0f78fc31b() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeHeroSlides(cms);
    list.push((0, $fGko7.createEmptyHeroSlide)());
    cms.heroSlides = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
}
function $78ab60f00f1c160f$export$2728136bea1f57a3(index) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeHeroSlides(cms);
    if (list.length <= 1 || index < 0 || index >= list.length) return false;
    list.splice(index, 1);
    cms.heroSlides = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
    return true;
}
function $78ab60f00f1c160f$export$7c94d757969729ab(index, fieldName, value) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeHeroSlides(cms);
    if (!list[index]) return;
    list[index] = {
        ...list[index],
        [fieldName]: value
    };
    cms.heroSlides = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
}
function $78ab60f00f1c160f$export$af83fdf91bbc50e3(index, fieldName) {
    return $78ab60f00f1c160f$export$8ccf9b9807721612()[index]?.[fieldName] ?? "";
}
function $78ab60f00f1c160f$var$materializeStoryParagraphs(cms) {
    if (!Array.isArray(cms.storyParagraphs)) cms.storyParagraphs = (0, $fGko7.defaultStoryParagraphs).map((text, index)=>{
        const override = cms.text?.[`home.story.p${index + 1}`];
        return override ?? text;
    });
    return cms.storyParagraphs;
}
function $78ab60f00f1c160f$export$f5e1209a388a275c() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    return [
        ...$78ab60f00f1c160f$var$materializeStoryParagraphs(cms)
    ];
}
function $78ab60f00f1c160f$export$adf0993945ee3e86() {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeStoryParagraphs(cms);
    list.push((0, $fGko7.createEmptyStoryParagraph)());
    cms.storyParagraphs = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
}
function $78ab60f00f1c160f$export$4086df54b404ea87(index) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeStoryParagraphs(cms);
    if (list.length <= 1 || index < 0 || index >= list.length) return false;
    list.splice(index, 1);
    cms.storyParagraphs = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
    return true;
}
function $78ab60f00f1c160f$export$deddb0f114322c4c(index, value) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const list = $78ab60f00f1c160f$var$materializeStoryParagraphs(cms);
    if (!list[index]) return;
    list[index] = value;
    cms.storyParagraphs = list;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
}
function $78ab60f00f1c160f$export$5471562007a6009(index) {
    return $78ab60f00f1c160f$export$f5e1209a388a275c()[index] ?? "";
}
function $78ab60f00f1c160f$export$350ef79c0617f8ee({ sectionId: sectionId, itemIndex: itemIndex, fieldName: fieldName, value: value, isSectionTitle: isSectionTitle }) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const menu = cms.menu ?? $78ab60f00f1c160f$export$b59bc15d9bae6f2a();
    const section = menu.find((s)=>s.id === sectionId);
    if (!section) return;
    if (isSectionTitle) section.title = value;
    else if (itemIndex >= 0 && section.items[itemIndex]) {
        if (value) section.items[itemIndex][fieldName] = value;
        else delete section.items[itemIndex][fieldName];
    }
    cms.menu = menu;
    $78ab60f00f1c160f$export$1586565df91ed028(cms);
}
function $78ab60f00f1c160f$export$b7b5d860b0808a2d({ sectionId: sectionId, itemIndex: itemIndex, fieldName: fieldName, isSectionTitle: isSectionTitle }) {
    const cms = $78ab60f00f1c160f$export$94db5ff3b913fcae();
    const menu = cms.menu ?? $78ab60f00f1c160f$export$b59bc15d9bae6f2a();
    const section = menu.find((s)=>s.id === sectionId);
    if (!section) return "";
    if (isSectionTitle) return section.title;
    return section.items[itemIndex]?.[fieldName] ?? "";
}

});
parcelRegister("2xpOo", function(module, exports) {

$parcel$export(module.exports, "menuSections", () => $1d92af8a5ab14ab9$export$e61faca1c3419ff8);
const $1d92af8a5ab14ab9$export$e61faca1c3419ff8 = [
    {
        id: "starters",
        title: "\u05DE\u05E0\u05D5\u05EA \u05D4\u05D9\u05DB\u05E8\u05D5\u05EA",
        items: [
            {
                name: "\u05E7\u05DC\u05D0\u05E1\u05D9",
                sizes: "200 / 300 / 400 \u05D2\u05F3",
                price: "43 / 51 / 59 \u20AA",
                desc: "\u05D1\u05D5\u05E8\u05D2\u05E8 \u05D1\u05E7\u05E8 \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05D9\u05E8\u05E7\u05D5\u05EA \u05D8\u05E8\u05D9\u05D9\u05DD"
            },
            {
                name: "\u05D0\u05E0\u05D2\u05D5\u05E1",
                sizes: "200 / 400 \u05D2\u05F3",
                price: "47 / 63 \u20AA",
                desc: "\u05D1\u05E9\u05E8 \u05D0\u05E0\u05D8\u05E8\u05D9\u05E7\u05D5\u05D8 \u05D0\u05E0\u05D2\u05D5\u05E1 \u05DE\u05D5\u05D1\u05D7\u05E8, \u05DE\u05D5\u05D2\u05E9 \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05D9\u05E8\u05E7\u05D5\u05EA \u05D8\u05E8\u05D9\u05D9\u05DD"
            },
            {
                name: "\u05D1\u05D5\u05E8\u05D2\u05E8 \u05E9\u05E0\u05D9\u05E6\u05DC\u05D5\u05E0\u05D9\u05DD",
                sizes: "120 \u05D2\u05F3",
                price: "37 \u20AA",
                desc: "\u05E9\u05E0\u05D9\u05E6\u05DC\u05D5\u05E0\u05D9\u05DD \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05D9\u05E8\u05E7\u05D5\u05EA \u05D8\u05E8\u05D9\u05D9\u05DD"
            },
            {
                name: "\u05DE\u05D9\u05E0\u05D9 \u05D1\u05D5\u05E8\u05D2\u05E8",
                price: "34 \u20AA",
                desc: "\u05D4\u05DE\u05D1\u05D5\u05E8\u05D2\u05E8 \u05DC\u05E7\u05D8\u05E0\u05D8\u05E0\u05D9\u05DD \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05D9\u05E8\u05E7\u05D5\u05EA"
            }
        ]
    },
    {
        id: "sides",
        title: "\u05EA\u05D5\u05E1\u05E4\u05D5\u05EA",
        items: [
            {
                name: "\u05E6\u05D9\u05E4\u05E1",
                price: "13 / 21 \u20AA"
            },
            {
                name: "\u05D8\u05D1\u05E2\u05D5\u05EA \u05D1\u05E6\u05DC",
                price: "13 / 21 \u20AA"
            },
            {
                name: "\u05E6\u05D9\u05E4\u05E1 \u05D1\u05D8\u05D8\u05D4",
                price: "16 / 28 \u20AA"
            },
            {
                name: "\u05DB\u05D3\u05D5\u05E8\u05D9 \u05E4\u05D9\u05E8\u05D4",
                price: "16 / 28 \u20AA"
            },
            {
                name: "\u05E9\u05E0\u05D9\u05E6\u05DC\u05D5\u05E0\u05D9\u05DD \u05D5\u05E6\u05D9\u05E4\u05E1",
                price: "31 \u20AA"
            },
            {
                name: "\u05E9\u05E0\u05D9\u05E6\u05DC\u05D5\u05E0\u05D9\u05DD",
                price: "21 / 35 \u20AA"
            },
            {
                name: "\u05DE\u05D9\u05E7\u05E1 \u05DE\u05D8\u05D5\u05D2\u05E0\u05D9\u05DD \u05E2\u05E0\u05E7",
                price: "31 \u20AA",
                desc: "\u05DE\u05D2\u05D9\u05E2 \u05E2\u05DD \u05E6\u05D9\u05E4\u05E1, \u05D8\u05D1\u05E2\u05D5\u05EA \u05D1\u05E6\u05DC \u05D5\u05E9\u05E0\u05D9\u05E6\u05DC\u05D5\u05E0\u05D9\u05DD"
            }
        ]
    },
    {
        id: "toppings",
        title: "\u05EA\u05D5\u05E1\u05E4\u05D5\u05EA \u05DE\u05E2\u05DC",
        items: [
            {
                name: "\u05D1\u05E6\u05DC \u05DE\u05D8\u05D5\u05D2\u05DF",
                price: "5 \u20AA"
            },
            {
                name: "\u05E4\u05D8\u05E8\u05D9\u05D5\u05EA",
                price: "8 \u20AA"
            },
            {
                name: "\u05D7\u05DC\u05E4\u05D9\u05E0\u05D9\u05D5",
                price: "6 \u20AA"
            },
            {
                name: "\u05E8\u05D9\u05D1\u05EA \u05D1\u05E6\u05DC",
                price: "10 \u20AA"
            },
            {
                name: "\u05D1\u05D9\u05E6\u05EA \u05E2\u05D9\u05DF",
                price: "7 \u20AA"
            },
            {
                name: "\u05D0\u05D5\u05D5\u05D6 \u05DE\u05E2\u05D5\u05E9\u05DF",
                price: "13 / 23 \u20AA"
            },
            {
                name: "\u05D7\u05DE\u05D0\u05EA \u05D1\u05D5\u05D8\u05E0\u05D9\u05DD",
                price: "8 \u20AA"
            },
            {
                name: "\u05D0\u05E1\u05D0\u05D3\u05D5 \u05DE\u05E4\u05D5\u05E8\u05E7",
                price: "18 / 34 \u20AA"
            }
        ]
    },
    {
        id: "wraps",
        title: "\u05D8\u05D5\u05E8\u05D8\u05D9\u05D5\u05EA",
        items: [
            {
                name: "\u05D8\u05D5\u05E8\u05D8\u05D9\u05D4 \u05D4\u05D1\u05D9\u05EA",
                price: "44 \u20AA",
                desc: "120 \u05D2\u05F3 \u05D1\u05E7\u05E8, \u05D0\u05D5\u05D5\u05D6 \u05DE\u05E2\u05D5\u05E9\u05DF \u05D5\u05E8\u05D9\u05D1\u05EA \u05D1\u05E6\u05DC \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05D9\u05E8\u05E7\u05D5\u05EA \u05D8\u05E8\u05D9\u05D9\u05DD \u05D5\u05E8\u05D5\u05D8\u05D1 \u05D4\u05D1\u05D9\u05EA"
            },
            {
                name: "\u05D8\u05D5\u05E8\u05D8\u05D9\u05D4 \u05E9\u05E0\u05D9\u05E6\u05DC",
                price: "34 \u20AA",
                desc: "120 \u05D2\u05F3 \u05E9\u05E0\u05D9\u05E6\u05DC \u05E2\u05DD \u05E8\u05D5\u05D8\u05D1 \u05D4\u05D1\u05D9\u05EA \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05D9\u05E8\u05E7\u05D5\u05EA \u05D8\u05E8\u05D9\u05D9\u05DD"
            },
            {
                name: "\u05D8\u05D5\u05E8\u05D8\u05D9\u05D4 \u05D1\u05E7\u05E8 \u05E7\u05E6\u05D5\u05E5",
                price: "36 \u20AA",
                desc: "120 \u05D2\u05F3 \u05D1\u05E7\u05E8 \u05E2\u05DC \u05D4\u05E4\u05DC\u05E0\u05E6'\u05D4 \u05D1\u05D8\u05D9\u05D1\u05D5\u05DC \u05D4\u05D1\u05D9\u05EA, \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05D9\u05E8\u05E7\u05D5\u05EA \u05D8\u05E8\u05D9\u05D9\u05DD"
            },
            {
                name: "\u05D8\u05D5\u05E8\u05D8\u05D9\u05D4 \u05D0\u05E0\u05D8\u05E8\u05D9\u05E7\u05D5\u05D8",
                price: "37 \u20AA",
                desc: "120 \u05D2\u05F3 \u05D0\u05E0\u05D8\u05E8\u05D9\u05E7\u05D5\u05D8 \u05E2\u05E1\u05D9\u05E1\u05D9 \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05D9\u05E8\u05E7\u05D5\u05EA \u05D8\u05E8\u05D9\u05D9\u05DD \u05D5\u05E8\u05D5\u05D8\u05D1 \u05D4\u05D1\u05D9\u05EA"
            },
            {
                name: "\u05D8\u05D5\u05E8\u05D8\u05D9\u05D4 \u05E6\u05D9\u05DE\u05D7\u05D5\u05E0\u05D9\u05EA",
                price: "29 \u20AA",
                desc: "\u05D7\u05D1\u05D9\u05EA\u05D4 \u05E2\u05DD \u05D1\u05E6\u05DC \u05DE\u05D8\u05D5\u05D2\u05DF \u05D5\u05E4\u05D8\u05E8\u05D9\u05D5\u05EA \u05D1\u05DC\u05D9\u05D5\u05D5\u05D9 \u05D9\u05E8\u05E7\u05D5\u05EA \u05D8\u05E8\u05D9\u05D9\u05DD"
            }
        ]
    },
    {
        id: "specials",
        title: "\u05D4\u05DE\u05D9\u05D5\u05D7\u05D3\u05D9\u05DD",
        items: [
            {
                name: "\u05D1\u05D9\u05D2 \u05DE\u05D9\u05D5\u05E8\u05E7\u05D5",
                price: "93 \u20AA",
                desc: "400 \u05D2\u05F3 \u05D1\u05E7\u05E8 + 200 \u05D2\u05F3 \u05D0\u05E0\u05D8\u05E8\u05D9\u05E7\u05D5\u05D8, \u05D0\u05E1\u05D0\u05D3\u05D5 \u05DE\u05E4\u05D5\u05E8\u05E7, \u05D1\u05D9\u05E6\u05EA \u05E2\u05D9\u05DF \u05D5\u05D1\u05E6\u05DC \u05DE\u05D8\u05D5\u05D2\u05DF"
            },
            {
                name: "\u05E7\u05E8\u05D9\u05D9\u05D6\u05D9 \u05DE\u05D9\u05D4",
                price: "61 \u20AA",
                desc: "400 \u05D2\u05F3 \u05D0\u05E0\u05D8\u05E8\u05D9\u05E7\u05D5\u05D8, \u05D0\u05D5\u05D5\u05D6 \u05DE\u05E2\u05D5\u05E9\u05DF, \u05D1\u05E6\u05DC \u05DE\u05D8\u05D5\u05D2\u05DF \u05D5\u05D7\u05DE\u05D0\u05EA \u05D1\u05D5\u05D8\u05E0\u05D9\u05DD"
            },
            {
                name: "\u05E7\u05E6\u05D9\u05DF \u05E6\u05D4\u05D5\u05D1",
                price: "59 \u20AA",
                desc: "200 \u05D2\u05F3 \u05D0\u05E0\u05D8\u05E8\u05D9\u05E7\u05D5\u05D8, \u05D7\u05DC\u05E4\u05D9\u05E0\u05D9\u05D5 \u05D5\u05D0\u05D5\u05D5\u05D6 \u05DE\u05E2\u05D5\u05E9\u05DF"
            },
            {
                name: "\u05DE\u05E0\u05EA \u05D4\u05D1\u05D9\u05EA",
                price: "59 \u20AA",
                desc: "200 \u05D2\u05F3 \u05D1\u05E7\u05E8, \u05D0\u05D5\u05D5\u05D6 \u05DE\u05E2\u05D5\u05E9\u05DF, \u05E8\u05D9\u05D1\u05EA \u05D1\u05E6\u05DC \u05D5\u05E8\u05D5\u05D8\u05D1 \u05E7\u05D0\u05E8\u05D9"
            }
        ]
    },
    {
        id: "drinks",
        title: "\u05E9\u05EA\u05D9\u05D9\u05D4",
        items: [
            {
                name: "\u05D1\u05E7\u05D1\u05D5\u05E7 \u05D2\u05D3\u05D5\u05DC 1 \u05DC\u05D9\u05D8\u05E8",
                price: "12 \u20AA"
            },
            {
                name: "\u05E4\u05D7\u05D9\u05EA",
                price: "9 \u20AA"
            },
            {
                name: "\u05DE\u05D9\u05DD / \u05E1\u05D5\u05D3\u05D4",
                price: "6 \u20AA"
            }
        ]
    }
];

});

parcelRegister("hHYpn", function(module, exports) {

$parcel$export(module.exports, "resolveImageSrc", () => $ce454fa51cd80f20$export$ff064696321480cc);
$parcel$export(module.exports, "shouldPersistImage", () => $ce454fa51cd80f20$export$6c35dcc278f6d023);
$parcel$export(module.exports, "isLegacyPicPath", () => (parcelRequire("dlkUe")).isLegacyPicPath);
$parcel$export(module.exports, "isCustomImageSrc", () => (parcelRequire("dlkUe")).isCustomImageSrc);

var $dlkUe = parcelRequire("dlkUe");
function $ce454fa51cd80f20$var$isParcelHashedSrc(value) {
    return /^(?:\/|\.\/)?[^/]+\.[a-f0-9]{6,}\.(jpe?g|png|webp|gif|svg)$/i.test(value);
}
function $ce454fa51cd80f20$var$basenameFromImageSrc(value) {
    const match = String(value).match(/\/([^/?#]+?)(?:\.[a-f0-9]{6,})?(?:\.(jpe?g|png|webp|gif|svg))(?:[?#]|$)/i);
    return match?.[1] ?? "";
}
function $ce454fa51cd80f20$export$ff064696321480cc(value, el) {
    if (!value?.trim()) return null;
    if ((0, $dlkUe.isCustomImageSrc)(value)) return value;
    const current = el?.getAttribute("src") ?? "";
    if ((0, $dlkUe.isLegacyPicPath)(value)) {
        if (current && !(0, $dlkUe.isLegacyPicPath)(current)) return null;
        return (0, $dlkUe.resolvePicSrc)(value);
    }
    if ($ce454fa51cd80f20$var$isParcelHashedSrc(value) && current && current !== value) {
        const storedBase = $ce454fa51cd80f20$var$basenameFromImageSrc(value);
        const currentBase = $ce454fa51cd80f20$var$basenameFromImageSrc(current);
        if (storedBase && currentBase && storedBase === currentBase) return null;
    }
    return value;
}
function $ce454fa51cd80f20$export$6c35dcc278f6d023(value, defaultValue) {
    if (!value?.trim()) return false;
    if (value === defaultValue) return false;
    if ((0, $dlkUe.isLegacyPicPath)(value) && (0, $dlkUe.isLegacyPicPath)(defaultValue)) return false;
    return true;
}

});
parcelRegister("dlkUe", function(module, exports) {

$parcel$export(module.exports, "isCustomImageSrc", () => $9b6d73fec3b84c06$export$f4d93d0fdf521f8a);
$parcel$export(module.exports, "isLegacyPicPath", () => $9b6d73fec3b84c06$export$c475fc86210b1e11);
$parcel$export(module.exports, "resolvePicSrc", () => $9b6d73fec3b84c06$export$1d821f8eff4635ee);
$parcel$export(module.exports, "resolveBranchImageSrc", () => $9b6d73fec3b84c06$export$66f8689ea29a250c);
function $9b6d73fec3b84c06$export$f4d93d0fdf521f8a(value) {
    if (!value?.trim()) return false;
    return value.startsWith("data:") || value.startsWith("blob:") || value.startsWith("http://") || value.startsWith("https://");
}
function $9b6d73fec3b84c06$export$c475fc86210b1e11(value) {
    if (!value) return false;
    return /^(?:\.\.\/)?pic\//.test(value) || /^\/pic\//.test(value);
}






const $9b6d73fec3b84c06$export$192631ce5ea4519e = {
    shomron: new URL((parcelRequire("f0qio"))).href,
    telmon: new URL((parcelRequire("ddGWO"))).href,
    beitel: new URL((parcelRequire("ccwzE"))).href,
    tapuach: new URL((parcelRequire("4gqgm"))).href,
    ariel: new URL((parcelRequire("5pelT"))).href,
    yakir: new URL((parcelRequire("dDbTU"))).href
};

const $9b6d73fec3b84c06$var$branchImagesByFile = {
    "karniSOM.jpg": $9b6d73fec3b84c06$export$192631ce5ea4519e.shomron,
    "talmon2.jpg": $9b6d73fec3b84c06$export$192631ce5ea4519e.telmon,
    "orders1.jpeg": $9b6d73fec3b84c06$export$192631ce5ea4519e.beitel,
    "tapuach.jpg": $9b6d73fec3b84c06$export$192631ce5ea4519e.tapuach,
    "ariel.jpg": $9b6d73fec3b84c06$export$192631ce5ea4519e.ariel,
    "yakir.jpg": $9b6d73fec3b84c06$export$192631ce5ea4519e.yakir,
    "logoround.png": new URL((parcelRequire("atN7U"))).href
};

















const $9b6d73fec3b84c06$export$ee81fb0c07f98137 = {
    "gallery1.jpg": new URL((parcelRequire("4iEd1"))).href,
    "gallery2.jpg": new URL((parcelRequire("9NLb7"))).href,
    "gallery3.jpg": new URL((parcelRequire("9AOvh"))).href,
    "gallery4.jpg": new URL((parcelRequire("94yqP"))).href,
    "gallery5.jpg": new URL((parcelRequire("6Re1z"))).href,
    "gallery6.jpg": new URL((parcelRequire("gfTvk"))).href,
    "gallery7.jpg": new URL((parcelRequire("kjHMI"))).href,
    "gallery8.jpg": new URL((parcelRequire("04tjC"))).href,
    "gallery9.jpg": new URL((parcelRequire("7iimD"))).href,
    "gallery10.jpg": new URL((parcelRequire("kfnXA"))).href,
    "gallery11.jpg": new URL((parcelRequire("3DNvb"))).href,
    "gallery12.jpg": new URL((parcelRequire("7cxMK"))).href,
    "gallery13.jpg": new URL((parcelRequire("7khlU"))).href,
    "gallery14.jpg": new URL((parcelRequire("lqoDk"))).href,
    "gallery15.jpg": new URL((parcelRequire("6EZqR"))).href,
    "orders1.jpeg": $9b6d73fec3b84c06$var$branchImagesByFile["orders1.jpeg"],
    "logoround.png": $9b6d73fec3b84c06$var$branchImagesByFile["logoround.png"],
    "karniSOM.jpg": $9b6d73fec3b84c06$var$branchImagesByFile["karniSOM.jpg"],
    "talmon2.jpg": $9b6d73fec3b84c06$var$branchImagesByFile["talmon2.jpg"],
    "tapuach.jpg": $9b6d73fec3b84c06$var$branchImagesByFile["tapuach.jpg"],
    "ariel.jpg": $9b6d73fec3b84c06$var$branchImagesByFile["ariel.jpg"],
    "yakir.jpg": $9b6d73fec3b84c06$var$branchImagesByFile["yakir.jpg"],
    "branchesPic.jpg": new URL((parcelRequire("eNIZ6"))).href,
    "plancha.jpg": new URL((parcelRequire("aW7kH"))).href
};
function $9b6d73fec3b84c06$var$filenameFromPicRef(value) {
    const raw = String(value).trim();
    const withoutQuery = raw.split(/[?#]/)[0];
    const basename = withoutQuery.replace(/^.*\//, "");
    return basename.replace(/\.[a-f0-9]{6,}(?=\.(?:jpe?g|png|webp|gif)$)/i, "");
}
function $9b6d73fec3b84c06$export$1d821f8eff4635ee(value) {
    if (!value?.trim()) return $9b6d73fec3b84c06$export$ee81fb0c07f98137["logoround.png"];
    if ($9b6d73fec3b84c06$export$f4d93d0fdf521f8a(value)) return value;
    if (!$9b6d73fec3b84c06$export$c475fc86210b1e11(value) && /\.[a-f0-9]{6,}\.(?:jpe?g|png|webp|gif)$/i.test(value)) return value;
    const filename = $9b6d73fec3b84c06$var$filenameFromPicRef(value);
    if (filename && $9b6d73fec3b84c06$export$ee81fb0c07f98137[filename]) return $9b6d73fec3b84c06$export$ee81fb0c07f98137[filename];
    if (!$9b6d73fec3b84c06$export$c475fc86210b1e11(value)) return value;
    return $9b6d73fec3b84c06$export$ee81fb0c07f98137["logoround.png"];
}
function $9b6d73fec3b84c06$export$66f8689ea29a250c(branchId, value) {
    if (value && $9b6d73fec3b84c06$export$f4d93d0fdf521f8a(value)) return value;
    if (value && !$9b6d73fec3b84c06$export$c475fc86210b1e11(value)) return value;
    if (branchId && $9b6d73fec3b84c06$export$192631ce5ea4519e[branchId]) return $9b6d73fec3b84c06$export$192631ce5ea4519e[branchId];
    if (value && $9b6d73fec3b84c06$export$c475fc86210b1e11(value)) {
        const filename = value.replace(/^(\.\.\/)?(?:pic\/)?/, "").replace(/^\/pic\//, "");
        if ($9b6d73fec3b84c06$var$branchImagesByFile[filename]) return $9b6d73fec3b84c06$var$branchImagesByFile[filename];
    }
    return $9b6d73fec3b84c06$var$branchImagesByFile["logoround.png"];
}

});
parcelRegister("f0qio", function(module, exports) {
module.exports = import.meta.resolve("kvbmM");

});

parcelRegister("ddGWO", function(module, exports) {
module.exports = import.meta.resolve("3IXap");

});

parcelRegister("ccwzE", function(module, exports) {
module.exports = import.meta.resolve("91pcq");

});

parcelRegister("4gqgm", function(module, exports) {
module.exports = import.meta.resolve("bZaBz");

});

parcelRegister("5pelT", function(module, exports) {
module.exports = import.meta.resolve("8rvZX");

});

parcelRegister("dDbTU", function(module, exports) {
module.exports = import.meta.resolve("fKKx3");

});

parcelRegister("atN7U", function(module, exports) {
module.exports = import.meta.resolve("JX7O6");

});

parcelRegister("4iEd1", function(module, exports) {
module.exports = import.meta.resolve("eqf4g");

});

parcelRegister("9NLb7", function(module, exports) {
module.exports = import.meta.resolve("jCSmn");

});

parcelRegister("9AOvh", function(module, exports) {
module.exports = import.meta.resolve("hqanZ");

});

parcelRegister("94yqP", function(module, exports) {
module.exports = import.meta.resolve("aS69D");

});

parcelRegister("6Re1z", function(module, exports) {
module.exports = import.meta.resolve("jBzpT");

});

parcelRegister("gfTvk", function(module, exports) {
module.exports = import.meta.resolve("8KpX7");

});

parcelRegister("kjHMI", function(module, exports) {
module.exports = import.meta.resolve("jJtrA");

});

parcelRegister("04tjC", function(module, exports) {
module.exports = import.meta.resolve("kiqHl");

});

parcelRegister("7iimD", function(module, exports) {
module.exports = import.meta.resolve("5YRqv");

});

parcelRegister("kfnXA", function(module, exports) {
module.exports = import.meta.resolve("3n8Hp");

});

parcelRegister("3DNvb", function(module, exports) {
module.exports = import.meta.resolve("k30q0");

});

parcelRegister("7cxMK", function(module, exports) {
module.exports = import.meta.resolve("iEyAJ");

});

parcelRegister("7khlU", function(module, exports) {
module.exports = import.meta.resolve("2a1NP");

});

parcelRegister("lqoDk", function(module, exports) {
module.exports = import.meta.resolve("4nSeX");

});

parcelRegister("6EZqR", function(module, exports) {
module.exports = import.meta.resolve("3TyAk");

});

parcelRegister("eNIZ6", function(module, exports) {
module.exports = import.meta.resolve("cBCRN");

});

parcelRegister("aW7kH", function(module, exports) {
module.exports = import.meta.resolve("13ygR");

});



parcelRegister("fczhV", function(module, exports) {

$parcel$export(module.exports, "MENU_FIELD_LABELS", () => $b1135978cb4392b3$export$fc52ed67b147b500);
$parcel$export(module.exports, "MENU_EMPTY_PLACEHOLDERS", () => $b1135978cb4392b3$export$9450897363e875d7);
$parcel$export(module.exports, "createEmptyMenuItem", () => $b1135978cb4392b3$export$7fc95fb33de62aa0);
const $b1135978cb4392b3$export$fc52ed67b147b500 = {
    name: "\u05E9\u05DD \u05D4\u05DE\u05E0\u05D4",
    price: "\u05DE\u05D7\u05D9\u05E8",
    sizes: "\u05D2\u05D5\u05D3\u05DC / \u05DE\u05E9\u05E7\u05DC",
    desc: "\u05EA\u05D9\u05D0\u05D5\u05E8"
};
const $b1135978cb4392b3$export$9450897363e875d7 = {
    sizes: "\u05D2\u05D5\u05D3\u05DC / \u05DE\u05E9\u05E7\u05DC (\u05DC\u05D0 \u05D7\u05D5\u05D1\u05D4)",
    desc: "\u05EA\u05D9\u05D0\u05D5\u05E8 \u05D4\u05DE\u05E0\u05D4 (\u05DC\u05D0 \u05D7\u05D5\u05D1\u05D4)"
};
function $b1135978cb4392b3$export$7fc95fb33de62aa0() {
    return {
        name: "\u05DE\u05E0\u05D4 \u05D7\u05D3\u05E9\u05D4",
        price: "0 \u20AA",
        sizes: "",
        desc: ""
    };
}

});

parcelRegister("fneK1", function(module, exports) {

$parcel$export(module.exports, "createEmptyBranch", () => $b314704d4e771b03$export$4ae1a128ed2013ab);
function $b314704d4e771b03$export$4ae1a128ed2013ab() {
    return {
        title: "\u05E1\u05E0\u05D9\u05E3 \u05D7\u05D3\u05E9",
        branch: "\u05E1\u05E0\u05D9\u05E3 \u05D7\u05D3\u05E9",
        address: "",
        time: "",
        waze: "",
        map: "",
        image: "../pic/logoround.png"
    };
}

});

parcelRegister("fGko7", function(module, exports) {

$parcel$export(module.exports, "defaultGallery", () => $b6aa97df20130a2a$export$adda827bd9d8c5b6);
$parcel$export(module.exports, "defaultHeroSlides", () => $b6aa97df20130a2a$export$37a05d1bd8bd201c);
$parcel$export(module.exports, "defaultStoryParagraphs", () => $b6aa97df20130a2a$export$f599337acf68d40b);
$parcel$export(module.exports, "createEmptyGalleryItem", () => $b6aa97df20130a2a$export$5f23571b30d1e896);
$parcel$export(module.exports, "createEmptyHeroSlide", () => $b6aa97df20130a2a$export$29c167888e7b878c);
$parcel$export(module.exports, "createEmptyStoryParagraph", () => $b6aa97df20130a2a$export$62b7967168a338b2);
const $b6aa97df20130a2a$export$adda827bd9d8c5b6 = [
    {
        src: "../pic/gallery8.jpg",
        alt: "\u05DE\u05E0\u05D4 \u05DE\u05D4\u05DE\u05D8\u05D1\u05D7"
    },
    {
        src: "../pic/gallery9.jpg",
        alt: "\u05D1\u05D5\u05E8\u05D2\u05E8 \u05D8\u05E8\u05D9"
    },
    {
        src: "../pic/gallery10.jpg",
        alt: "\u05DE\u05E0\u05D4 \u05DE\u05D4\u05EA\u05E4\u05E8\u05D9\u05D8"
    },
    {
        src: "../pic/gallery14.jpg",
        alt: "\u05D0\u05D5\u05DB\u05DC \u05DE\u05D4\u05D2\u05E8\u05D9\u05DC"
    },
    {
        src: "../pic/gallery13.jpg",
        alt: "\u05DE\u05E0\u05D4 \u05DE\u05D9\u05D5\u05D7\u05D3\u05EA"
    },
    {
        src: "../pic/gallery12.jpg",
        alt: "\u05EA\u05D5\u05E1\u05E4\u05D5\u05EA"
    },
    {
        src: "../pic/gallery11.jpg",
        alt: "\u05D1\u05D5\u05E8\u05D2\u05E8\u05D8\u05D9\u05D9\u05DD"
    },
    {
        src: "../pic/gallery1.jpg",
        alt: "\u05DE\u05D8\u05D1\u05D7 \u05D1\u05E9\u05E8\u05D9"
    },
    {
        src: "../pic/gallery2.jpg",
        alt: "\u05DE\u05E0\u05D4 \u05D7\u05DE\u05D4"
    },
    {
        src: "../pic/gallery3.jpg",
        alt: "\u05DE\u05D4\u05EA\u05E4\u05E8\u05D9\u05D8"
    },
    {
        src: "../pic/gallery5.jpg",
        alt: "\u05D1\u05D5\u05E8\u05D2\u05E8 \u05E2\u05DC \u05D4\u05E4\u05DC\u05E0\u05E6'\u05D4"
    },
    {
        src: "../pic/gallery4.jpg",
        alt: "\u05DE\u05E0\u05D4 \u05DE\u05D4\u05E1\u05E0\u05D9\u05E3"
    },
    {
        src: "../pic/gallery7.jpg",
        alt: "\u05D0\u05D5\u05D5\u05D9\u05E8\u05EA \u05D4\u05DE\u05E1\u05E2\u05D3\u05D4"
    },
    {
        src: "../pic/gallery6.jpg",
        alt: "\u05DE\u05E0\u05D4 \u05DE\u05D4\u05DE\u05D8\u05D1\u05D7"
    },
    {
        src: "../pic/gallery15.jpg",
        alt: "\u05D1\u05D5\u05E8\u05D2\u05E8 \u05D8\u05E8\u05D9"
    },
    {
        src: "../pic/orders1.jpeg",
        alt: "\u05D4\u05D6\u05DE\u05E0\u05D4 \u05DE\u05D4\u05E1\u05E0\u05D9\u05E3"
    }
];
const $b6aa97df20130a2a$export$37a05d1bd8bd201c = [
    {
        src: "../pic/gallery5.jpg",
        alt: "\u05D1\u05D5\u05E8\u05D2\u05E8\u05D8\u05D9\u05D9\u05DD \u05E2\u05DC \u05D4\u05D2\u05E8\u05D9\u05DC"
    },
    {
        src: "../pic/gallery10.jpg",
        alt: "\u05DE\u05E0\u05D4 \u05DE\u05D4\u05EA\u05E4\u05E8\u05D9\u05D8"
    },
    {
        src: "../pic/gallery7.jpg",
        alt: "\u05D0\u05D5\u05D5\u05D9\u05E8\u05EA \u05D4\u05E1\u05E0\u05D9\u05E3"
    }
];
const $b6aa97df20130a2a$export$f599337acf68d40b = [
    "\u05E8\u05E9\u05EA \u05D1\u05D5\u05E8\u05D2\u05E8\u05D8\u05D9\u05D9\u05DD \u05E0\u05D5\u05E1\u05D3\u05D4 \u05D1\u05E2\u05E7\u05D1\u05D5\u05EA \u05D4\u05D1\u05D9\u05E7\u05D5\u05E9 \u05DC\u05DE\u05D8\u05D1\u05D7 \u05D1\u05E9\u05E8\u05D9 \u05D0\u05D9\u05DB\u05D5\u05EA\u05D9 \u05D1\u05E9\u05D5\u05DE\u05E8\u05D5\u05DF. \u05D4\u05D0\u05D4\u05D1\u05D4 \u05E9\u05DC\u05E0\u05D5 \u05DC\u05D0\u05D5\u05DB\u05DC \u05D4\u05E4\u05DB\u05D4 \u05D0\u05EA \u05D4\u05D7\u05D6\u05D5\u05DF \u05DC\u05DE\u05E6\u05D9\u05D0\u05D5\u05EA.",
    "\u05D4\u05EA\u05D7\u05DC\u05E0\u05D5 \u05DE\u05E4\u05D5\u05D3 \u05D8\u05E8\u05D0\u05E7 \u05DB\u05D3\u05D9 \u05DC\u05E4\u05E0\u05E7 \u05D0\u05EA \u05D4\u05D7\u05D9\u05D9\u05DC\u05D9\u05DD \u05D1\u05D0\u05D6\u05D5\u05E8, \u05D5\u05DB\u05D9\u05D5\u05DD \u05DC\u05E8\u05E9\u05EA \u05D1\u05D5\u05E8\u05D2\u05E8\u05D8\u05D9\u05D9\u05DD 6 \u05E1\u05E0\u05D9\u05E4\u05D9\u05DD \u05D1\u05E9\u05D5\u05DE\u05E8\u05D5\u05DF, \u05D4\u05EA\u05E4\u05E8\u05D9\u05D8 \u05D4\u05DE\u05D2\u05D5\u05D5\u05DF \u05D1\u05D9\u05D5\u05EA\u05E8 \u05D5\u05E9\u05D9\u05E8\u05D5\u05EA \u05DE\u05E9\u05DC\u05D5\u05D7\u05D9\u05DD \u05DE\u05D4\u05D9\u05E8.",
    "\u05D1\u05D5\u05E8\u05D2\u05E8\u05D8\u05D9\u05D9\u05DD \u05D3\u05D5\u05D2\u05DC\u05EA \u05D1\u05DE\u05E6\u05D5\u05D5\u05EA \u05D4\u05DB\u05E0\u05E1\u05EA \u05D0\u05D5\u05E8\u05D7\u05D9\u05DD \u05D5\u05D8\u05E2\u05DD \u05D9\u05E9\u05E8\u05D0\u05DC\u05D9 \u05D0\u05DE\u05D9\u05EA\u05D9."
];
function $b6aa97df20130a2a$export$5f23571b30d1e896() {
    return {
        src: "../pic/logoround.png",
        alt: "\u05EA\u05DE\u05D5\u05E0\u05D4 \u05D7\u05D3\u05E9\u05D4"
    };
}
function $b6aa97df20130a2a$export$29c167888e7b878c() {
    return {
        src: "../pic/logoround.png",
        alt: "\u05E9\u05E7\u05D5\u05E4\u05D9\u05EA \u05D7\u05D3\u05E9\u05D4"
    };
}
function $b6aa97df20130a2a$export$62b7967168a338b2() {
    return "\u05E4\u05E1\u05E7\u05D4 \u05D7\u05D3\u05E9\u05D4 \u2014 \u05DC\u05D7\u05E6\u05D5 \u05DC\u05E2\u05E8\u05D9\u05DB\u05D4";
}

});

parcelRegister("aStCm", function(module, exports) {

$parcel$export(module.exports, "readSession", () => $7eb5ec001515eb6e$export$98ac845cefcbe7a);
$parcel$export(module.exports, "sessionRequest", () => $7eb5ec001515eb6e$export$47b9268d903d24ae);
$parcel$export(module.exports, "authenticate", () => $7eb5ec001515eb6e$export$61bb00ddedae72e4);
$parcel$export(module.exports, "endSession", () => $7eb5ec001515eb6e$export$17a5be43989a0bc1);
// Credentials are checked only by the server; never bundle them into the site.
const $7eb5ec001515eb6e$var$AUTH_API = "./api/auth.php";
let $7eb5ec001515eb6e$var$csrf;
async function $7eb5ec001515eb6e$export$98ac845cefcbe7a() {
    const response = await fetch($7eb5ec001515eb6e$var$AUTH_API, {
        credentials: "same-origin",
        cache: "no-store"
    });
    if (!response.ok) throw new Error("\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D1\u05D3\u05D5\u05E7 \u05D0\u05EA \u05D4\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA. \u05E0\u05E1\u05D5 \u05E9\u05D5\u05D1.");
    const session = await response.json();
    $7eb5ec001515eb6e$var$csrf = session.csrf;
    return session;
}
async function $7eb5ec001515eb6e$export$47b9268d903d24ae(url, body) {
    if (!$7eb5ec001515eb6e$var$csrf) await $7eb5ec001515eb6e$export$98ac845cefcbe7a();
    const response = await fetch(url, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": $7eb5ec001515eb6e$var$csrf
        },
        body: JSON.stringify(body)
    });
    const result = await response.json().catch(()=>({}));
    if (!response.ok || result.ok !== true) {
        if (response.status === 401 || response.status === 403) $7eb5ec001515eb6e$var$csrf = undefined;
        throw new Error(response.status === 401 ? "\u05E9\u05DD \u05D4\u05DE\u05E9\u05EA\u05DE\u05E9 \u05D0\u05D5 \u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05E9\u05D2\u05D5\u05D9\u05D9\u05DD, \u05D0\u05D5 \u05E9\u05D4\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA \u05E4\u05D2\u05D4." : "\u05D4\u05E4\u05E2\u05D5\u05DC\u05D4 \u05E0\u05DB\u05E9\u05DC\u05D4. \u05E0\u05E1\u05D5 \u05E9\u05D5\u05D1 \u05DE\u05D0\u05D5\u05D7\u05E8 \u05D9\u05D5\u05EA\u05E8.");
    }
    if (result.csrf) $7eb5ec001515eb6e$var$csrf = result.csrf;
    return result;
}
function $7eb5ec001515eb6e$export$61bb00ddedae72e4(user, pass) {
    return $7eb5ec001515eb6e$export$47b9268d903d24ae($7eb5ec001515eb6e$var$AUTH_API, {
        user: user,
        pass: pass
    });
}
async function $7eb5ec001515eb6e$export$17a5be43989a0bc1() {
    await $7eb5ec001515eb6e$export$47b9268d903d24ae($7eb5ec001515eb6e$var$AUTH_API, {
        action: "logout"
    });
    $7eb5ec001515eb6e$var$csrf = undefined;
}

});

parcelRegister("66oNf", function(module, exports) {

$parcel$export(module.exports, "fetchRemoteCms", () => $47168911095ea61f$export$ca592eb7e97d7a98);
$parcel$export(module.exports, "pushRemoteCms", () => $47168911095ea61f$export$bc1ffd38f9615a67);
$parcel$export(module.exports, "hasRemoteCmsContent", () => $47168911095ea61f$export$5fa52a9fdca09d31);

var $aStCm = parcelRequire("aStCm");
const $47168911095ea61f$var$CMS_API = "./api/cms.php";
async function $47168911095ea61f$export$ca592eb7e97d7a98() {
    const res = await fetch($47168911095ea61f$var$CMS_API, {
        cache: "no-store"
    });
    if (!res.ok) throw new Error(`CMS fetch failed (${res.status})`);
    const data = await res.json();
    return data && typeof data === "object" ? data : {};
}
async function $47168911095ea61f$export$bc1ffd38f9615a67(data) {
    await (0, $aStCm.sessionRequest)($47168911095ea61f$var$CMS_API, {
        data: data
    });
}
function $47168911095ea61f$export$5fa52a9fdca09d31(data) {
    if (!data || typeof data !== "object") return false;
    return Boolean(data.menu || data.branches || data.branchList?.length || data.gallery?.length || data.heroSlides?.length || data.storyParagraphs?.length || data.text || data.images || data.links);
}

});



//# sourceMappingURL=BurgerMunch.8ee970a6.js.map
